import LoadingModal from 'components/LoadingModal/LoadingModal';
export default LoadingModal;
